import UseCurrentUserState from "CurrentUserState";

const currentUserState = UseCurrentUserState(true);

const CurrentUserData = () => {
  return currentUserState.get();
};

export default CurrentUserData;
